import { chakra } from '@chakra-ui/react';
import React from 'react';

import { IconButton } from 'toolkit/chakra/icon-button';
import IconSvg, { type IconName } from 'ui/shared/IconSvg';

interface Props {
  loading?: boolean;
  className?: string;
  icon?: IconName;
  boxSize?: number | string;
  iconSize?: number | string;
}

const AdditionalInfoButton = (props: Props, ref: React.ForwardedRef<HTMLButtonElement>) => {
  const { loading, icon, boxSize, iconSize, ...rest } = props;

  return (
    <IconButton
      ref={ ref }
      variant="icon_secondary"
      _open={{
        bgColor: 'selected.control.bg',
        color: 'selected.control.text',
      }}
      borderRadius="base"
      aria-label="Transaction info"
      boxSize={ boxSize || 6 }
      loadingSkeleton={ loading }
      { ...rest }
    >
      <IconSvg name={ icon || 'info' } boxSize={ iconSize || boxSize || 5 }/>
    </IconButton>
  );
};

export default chakra(React.forwardRef(AdditionalInfoButton));
